import isPropValid from '@emotion/is-prop-valid';

export const shouldForwardProp = (tag: React.ElementType) =>
  typeof tag === 'string' && tag.charCodeAt(0) > 96
    ? isPropValid
    : (key: string) => key !== 'theme' && key !== 'innerRef';
